import { Variants } from 'framer-motion';

export const fadeIn = (
	direction: 'up' | 'down' | 'left' | 'right' | 'none' = 'up',
	delay: number = 0
): Variants => {
	return {
		hidden: {
			y: direction === 'up' ? 20 : direction === 'down' ? -20 : 0,
			x: direction === 'left' ? 20 : direction === 'right' ? -20 : 0,
			opacity: 0,
		},
		show: {
			y: 0,
			x: 0,
			opacity: 1,
			transition: {
				type: 'tween',
				ease: 'easeOut',
				duration: 0.5,
				delay,
			},
		},
	};
};

export const staggerContainer: Variants = {
	hidden: {},
	show: {
		transition: {
			staggerChildren: 0.1,
			delayChildren: 0.1,
		},
	},
};

export const scaleIn: Variants = {
	hidden: {
		opacity: 0,
		scale: 0.8,
	},
	show: {
		opacity: 1,
		scale: 1,
		transition: {
			type: 'spring',
			damping: 20,
			stiffness: 100,
		},
	},
};

export const slideIn = (
	direction: 'up' | 'down' | 'left' | 'right',
	delay: number = 0
): Variants => {
	return {
		hidden: {
			y: direction === 'up' ? 100 : direction === 'down' ? -100 : 0,
			x: direction === 'left' ? 100 : direction === 'right' ? -100 : 0,
			opacity: 0,
		},
		show: {
			y: 0,
			x: 0,
			opacity: 1,
			transition: {
				type: 'spring',
				damping: 20,
				stiffness: 100,
				duration: 0.8,
				delay,
			},
		},
	};
};
